import moment from 'moment';
import { ReusableDataTable } from '@operations/shared';
import { useDispatch } from 'react-redux';
import { getUnidentifiedCollectionInfo, stepperMoving } from '../../stores/actions';
import { getUnidentifiedCollectionsUnassignedApi } from '../../utils/apisConsts';
export default function ViewUnidentifiedCollections({ setIsCompany }: { setIsCompany: any }) {
    const dispatch = useDispatch();

    const handleSelectUnidentifiedCollection = (collectionInfo: any) => {
        setIsCompany(true)
        dispatch(getUnidentifiedCollectionInfo(collectionInfo))
        dispatch(stepperMoving(1))
    }

    const collectionId: any = {
        title: 'Collection ID',
        dataIndex: 'id',
        render: (_: any, collectionInfo: any) => (
            <div onClick={() => handleSelectUnidentifiedCollection(collectionInfo)}>
                <span style={{ textDecoration: 'underline', cursor: 'pointer' }}> {collectionInfo?.id}</span>
            </div>
        ),
    };

    let columns = [
        {
            title: 'Collection Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Collection Date',
            dataIndex: 'collectionDate',
            key: 'collectionDate',
            render: (collectionDate: any) => moment(collectionDate).format('LL')
        },
        {
            title: 'Collection Creation Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (createdAt: string) => moment(createdAt).format('LL')
        },
        {
            title: 'Comment',
            dataIndex: 'comment',
            key: 'comment',
        },
    ];

    columns = [collectionId, ...columns];

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <ReusableDataTable columns={columns} apiLink={getUnidentifiedCollectionsUnassignedApi} hiddenRefreshing
                    pagination={false} loading={false} scrolling={{ x: 100, y: 300 }} loadData={true} />
            </div>
        </>
    )
}
